import {
  BottomSheet,
  Illustration,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Box, CircularProgress, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { type PlacementDetail } from "../../api/useGetPlacement";
import { BrowseMoreJobsButton } from "../BrowseMoreJobsButton";
import { BrowseMyJobsButton } from "../BrowseMyJobs";

interface EasySchedulingInterviewRequestModalProps {
  modalState: UseModalState;
  placementDetails: PlacementDetail;
  isSubmitting: boolean;
}

export function EasySchedulingInterviewRequestModal(
  props: EasySchedulingInterviewRequestModalProps
) {
  const { modalState, placementDetails, isSubmitting } = props;

  const handleClose = () => {
    modalState.closeModal();
  };

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={handleClose} />}
      footer={
        !isSubmitting && (
          <DialogFooter orientation="vertical">
            <BrowseMoreJobsButton />
            <BrowseMyJobsButton
              applicationMethod={placementDetails.applicationMethod}
              buttonText="View my application"
              logMetadata={{
                workplaceId: placementDetails.workplace.id,
                placementId: placementDetails.id,
                buttonSource: "placement_details_page",
              }}
            />
          </DialogFooter>
        )
      }
    >
      <Box sx={{ px: 5, py: 6 }}>
        {isSubmitting ? (
          <Stack spacing={7} alignItems="center" justifyContent="center">
            <CircularProgress size={60} />
            <Text variant="h4" textAlign="center">
              Submitting interview request...
            </Text>
          </Stack>
        ) : (
          <Stack spacing={7} alignItems="center" justifyContent="center">
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <Illustration type="mail-person" />
            </Box>
            <Stack spacing={5} sx={{ paddingX: 10 }}>
              <Text variant="h2" textAlign="center">
                Interview request submitted!
              </Text>
              <Text
                variant="body1"
                textAlign="center"
                color={(theme) => theme.palette.text.secondary}
              >
                You&apos;ll receive a text message when {placementDetails.workplace.name} responds
                to your request
              </Text>
            </Stack>
          </Stack>
        )}
      </Box>
    </BottomSheet>
  );
}
